var retrieveTimings = function retrieveTimings(data) {
  var configTimings = data.timings || [];
  var timings = configTimings.reduce(function (entries, timing) {
    var startMark = data.metrics.marks.find(function (mark) {
      return mark.name === timing.startMark;
    });
    if (timing.startMark && !startMark) {
      return entries;
    }
    var endMark = data.metrics.marks.find(function (mark) {
      return mark.name === timing.endMark;
    });
    if (timing.endMark && !endMark) {
      return entries;
    }
    if (data.metrics.startTime === null || data.metrics.endTime === null) {
      return null;
    }
    var startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
    var duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
    entries["".concat(timing.key)] = {
      startTime: startTime,
      duration: duration
    };
    return entries;
  }, {});
  return timings;
};
export var customTimings = function customTimings(data) {
  if (!data.timings) {
    return null;
  }
  var timings = retrieveTimings(data);
  if (Object.keys(timings).length === 0) {
    return null;
  }
  return timings;
};